import { keyBy } from "lodash";

import {
  WordEqualsConditionBuilder,
  StartsWithConditionBuilder,
  EqualsConditionBuilder,
  EndsWithConditionBuilder,
  ContainsConditionBuilder,
} from ".";

export function getConditionBuilders() {
  return keyBy([
    WordEqualsConditionBuilder,
    StartsWithConditionBuilder,
    EqualsConditionBuilder,
    EndsWithConditionBuilder,
    ContainsConditionBuilder,
  ], 'type')
}
